// src/Dashboard/pages/user/Reglements/components/ReglementsToolbar.jsx

import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

export default function ReglementsToolbar({
  ui,
  seasons = [],
  updateUi,
  debouncedSearch,
  setDebouncedSearch,
  onReset,
}) {
  const fieldClass =
    "w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white";

  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="mb-4 flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="inline-flex items-center gap-2 text-sm font-bold text-slate-900 dark:text-white">
            <FaFilter />
            Filtres règlements
          </div>

          <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
            Recherchez une commande, filtrez par statut, saison ou type de
            règlement.
          </p>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="inline-flex items-center justify-center gap-2 rounded-2xl bg-slate-900 px-3 py-2 text-xs font-bold text-white transition hover:bg-slate-800 dark:bg-white dark:text-slate-900 dark:hover:bg-slate-100"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="grid grid-cols-1 gap-3 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Recherche
          </label>

          <div className="relative">
            <FaSearch className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

            <input
              type="text"
              value={debouncedSearch}
              onChange={(event) => setDebouncedSearch(event.target.value)}
              placeholder="Article, message, saison, statut..."
              className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Focus
          </label>

          <select
            value={ui.focus}
            onChange={(event) => updateUi({ focus: event.target.value })}
            className={fieldClass}
          >
            <option value="all">Tous les règlements</option>
            <option value="toPay">À régler</option>
            <option value="paid">Réglés</option>
            <option value="installments">Échéances</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Statut
          </label>

          <select
            value={ui.status}
            onChange={(event) => updateUi({ status: event.target.value })}
            className={fieldClass}
          >
            <option value="all">Tous les statuts</option>
            <option value="Non Réglé">Non réglé</option>
            <option value="En Attente">En attente</option>
            <option value="Réglé">Réglé</option>
            <option value="Partiellement Réglé">Partiellement réglé</option>
            <option value="Annulé">Annulé</option>
            <option value="Remboursé">Remboursé</option>
          </select>
        </div>

        <div>
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Saison
          </label>

          <select
            value={ui.season}
            onChange={(event) => updateUi({ season: event.target.value })}
            className={fieldClass}
          >
            <option value="all">Toutes les saisons</option>

            {seasons.map((season) => (
              <option key={season} value={season}>
                {season}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-1 gap-3 lg:grid-cols-5">
        <div className="lg:col-start-5">
          <label className="mb-1 block text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
            Tri
          </label>

          <select
            value={ui.sort}
            onChange={(event) => updateUi({ sort: event.target.value })}
            className={fieldClass}
          >
            <option value="dateDesc">Plus récents</option>
            <option value="dateAsc">Plus anciens</option>
            <option value="amountDesc">Montant décroissant</option>
            <option value="amountAsc">Montant croissant</option>
            <option value="alpha">Article A-Z</option>
          </select>
        </div>
      </div>
    </div>
  );
}